<template>
    <crash-form schema="new" />
</template>

<script>
import CrashForm from '../../components/Forms/crashForm.vue';

export default {
    components: { CrashForm }
}
</script>